import { AnalyticsClient } from '@modernhealth/web-analytics';

export const analyticsClient = new AnalyticsClient(process.env.REACT_APP_APP_NAME!);
